export const FORMATION_SHOW_RESET = "FORMATION_SHOW_RESET";
export const FORMATION_SHOW_SET_ERROR = "FORMATION_SHOW_SET_ERROR";
export const FORMATION_SHOW_SET_RETRIEVED = "FORMATION_SHOW_SET_RETRIEVED";
export const FORMATION_SHOW_TOGGLE_LOADING = "FORMATION_SHOW_TOGGLE_LOADING";
